import { TileMap, TileSize } from "game-common/models"

/**
 * Whether a world point is water, for things that are not the water layer -- the grass round a body's
 * feet, its footsteps. The water layer (water_layer.ts) publishes its BAKED shore per room once it has one,
 * so they follow the drawn edge; before that they fall back to the room's water cells.
 */
const presence = new Map<string, (px: number, py: number) => boolean>()

export const setWaterPresence = (roomId: string, at?: (px: number, py: number) => boolean): void => {
    if (at) presence.set(roomId, at)
    else presence.delete(roomId)
}

export const waterAt = (source: { roomId?: string; getWaterLayer?(): TileMap | undefined } | undefined,
    px: number, py: number): boolean => {
    if (!source) return false
    const baked = source.roomId ? presence.get(source.roomId) : undefined
    if (baked) return baked(px, py)
    const v = source.getWaterLayer?.()?.[Math.floor(px / TileSize)]?.[Math.floor(py / TileSize)]
    return !!v && v !== "0"
}
